import MapElement from './MapElement';
import 'ol/ol.css';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';

import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';

import { Pointer as PointerInteraction } from 'ol/interaction';
import Select from 'ol/interaction/Select';
import { getLength } from 'ol/sphere';
import Collection from 'ol/Collection';
import FeatureDrawer from '../helpers/FeatureDrawer';

export default class MapMotionplanDrawer extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
        this.source = null

        this.drawLayer()

        this.lastStartPoint = null
        this.targetLayerGroup = null
        this.hoverInteraction = null
    }

    drawLayer() {
        if (!this.layer) {
            this.source = new VectorSource();
            this.layer = new VectorLayer({
                source: this.source,
                style: new Style({
                    stroke: new Stroke({
                        color: '#ffcc33',
                        width: 2,
                    }),
                    image: new Circle({
                        fill: new Fill({
                            color: '#ffcc33'
                        }),
                        radius: 3,
                    }),

                }),
                zIndex: 203
                // style: style
            });
            this.mapModel.map.addLayer(this.layer);
        }
        this.source.clear();

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    setTargetLayer(targetLayerGroup) {
        this.targetLayerGroup = targetLayerGroup
    }

    drawLoadingLine(endCoordinates) {
        if (this.lastStartPoint) {
            const loadingLine = new Feature(new LineString([this.lastStartPoint, endCoordinates]))
            this.source.addFeature(loadingLine);
        }
    }

    layerFilter(layer) {
        var layerInTargetLayer = false

        // console.log(layer)
        // console.log(this.targetLayerGroup)

        if (this.targetLayerGroup.getLayers().getArray().includes(layer)) {
            layerInTargetLayer = true
        }

        // this.targetLayerGroup.getLayers().getArray().forEach(mpLayerGroup => {
        //     if (mpLayerGroup.get("parentId") == "MOTIONPLANCOLLECTION") {
        //         if (mpLayerGroup)

        //         if (mpLayerGroup.getLayers().getArray().includes(layer)) {
        //             layerInTargetLayer = true
        //         }
        //     } else {
        //         if (mpLayerGroup === layer) {
        //             layerInTargetLayer = true
        //         }
        //     }
        // })

        return layerInTargetLayer;
    }

    drawLine(startCoordinates) {
        const HIT_DETECTION_TOLERANCE = 5;

        this.lastStartPoint = startCoordinates;

        // Create a feature for the dynamic line
        const dynamicLine = new LineString([startCoordinates, startCoordinates]);
        const dynamicLineFeature = new Feature(dynamicLine);
        this.source.addFeature(dynamicLineFeature);

        // Retrieve all selected features from all select interactions
        const interactions = this.mapModel.map.getInteractions().getArray();
        let selectedFeatures = new Collection();
        interactions.forEach(interaction => {
            if (interaction instanceof Select) {
                selectedFeatures.extend(interaction.getFeatures().getArray());
            }
        });

        // Hover interaction
        //TODO: REMOVE INTERACTION IF EXISTS AND SET NEW ONE
        this.hoverInteraction = new PointerInteraction({
            handleMoveEvent: function (evt) {
                const pixel = evt.pixel;
                const coordinate = evt.coordinate;
                let snappedCoordinate = coordinate;

                // Check if cursor is over a line feature in the specific layer/layer group
                const features = this.mapModel.map.getFeaturesAtPixel(pixel, {
                    hitTolerance: HIT_DETECTION_TOLERANCE,
                    layerFilter: function (layer) {
                        // Modify this to match your target layer/layer group
                        return /*layer === this.targetLayer || */ this.layerFilter(layer)
                    }.bind(this)
                });

                if (features.length > 0) {
                    // console.log(selectedFeatures)
                    const filteredFeatures = features.filter(feature => !selectedFeatures.getArray().includes(feature));

                    if (filteredFeatures.length > 0) {
                        const closestFeature = filteredFeatures[0];
                        if (closestFeature.getGeometry().getType() === 'LineString') {
                            const closestVertex = this.findClosestEndPoint(closestFeature.getGeometry(), coordinate);
                            snappedCoordinate = closestVertex;
                        } else if (closestFeature.getGeometry().getType() === 'Point') {
                            snappedCoordinate = closestFeature.getGeometry().getCoordinates();
                        }
                    }
                }

                // Update the second coordinate of the dynamic line
                dynamicLine.setCoordinates([startCoordinates, snappedCoordinate]);

                // Update the feature's geometry to trigger a redraw
                dynamicLineFeature.setGeometry(dynamicLine);
            }.bind(this)

        });

        // Add pointerout event listener to detect when the pointer leaves the map container
        //TODO: REMOVE INTERACTION IF EXISTS AND SET NEW ONE
        this.mapModel.map.getViewport().addEventListener('pointerout', function () {

            dynamicLineFeature.setGeometry(null);
        });

        this.mapModel.map.addInteraction(this.hoverInteraction);
    }

    drawLineFromMotionplanPoint(point, projection) {
        const featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);

        let featurePoint = featureDrawer.drawFeature({ type: "POINT", x: point.x, y: point.y })

        this.drawLine(featurePoint.getGeometry().getCoordinates())
    }

    clearLine() {
        this.mapModel.map.removeInteraction(this.hoverInteraction);
        this.source.clear()
    }

    // Function to find the closest endpoint on a line to a given coordinate
    findClosestEndPoint(line, coordinate) {
        const vertices = line.getCoordinates();
        const endpoints = [vertices[0], vertices[vertices.length - 1]]
        let closestEndpoint = null;
        let minDistance = Infinity;

        endpoints.forEach(vertex => {
            const distance = getLength(new LineString([coordinate, vertex]));
            if (distance < minDistance) {
                minDistance = distance;
                closestEndpoint = vertex;
            }
        })

        return closestEndpoint;
    }

    // Function to find the furthest endpoint on a line to a given coordinate
    findFurthestEndpoint(line, coordinate) {
        const vertices = line.getCoordinates();
        const endpoints = [vertices[0], vertices[vertices.length - 1]]
        let furthestEndpoint = null;
        let maxDistance = 0;


        endpoints.forEach(vertex => {
            const distance = getLength(new LineString([coordinate, vertex]));
            if (distance > maxDistance) {
                maxDistance = distance;
                furthestEndpoint = vertex;
            }
        })

        return furthestEndpoint;
    }

    isStartSelected(line, coordinate) {
        const vertices = line.getCoordinates();
        const endpoints = [vertices[0], vertices[vertices.length - 1]]
        let vertIndex = 0;
        let minDistance = Infinity;


        endpoints.forEach((vertex, index) => {
            const distance = getLength(new LineString([coordinate, vertex]));
            if (distance < minDistance) {
                minDistance = distance;
                vertIndex = index;
            }
        });

        return vertIndex == 0
    }
}